import { useState } from 'react'
import { useUnit } from 'effector-react'
import { Button, Divider, Flex, Modal } from 'antd'
import { changeStatusBudgetPeriodFx } from 'src/pages/budget/budgetRequests/model'
import { STATUS_PERIOD } from 'src/pages/budget/const'
import { TStatusPeriod } from 'src/pages/budget/types'
import { BudgetPeriodState } from 'src/pages/budget/budgetRequests/types'

type Props = {
  budgetPeriod: BudgetPeriodState
}

type ButtonWithConfirmProps = {
  title: string
  confirmText: string
  loading: boolean
  color: 'red' | 'green'
  onConfirm: () => Promise<void>
}

const ButtonWithConfirm = ({
  title,
  confirmText,
  loading,
  color,
  onConfirm,
}: ButtonWithConfirmProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleConfirm = async () => {
    try {
      await onConfirm()
      setIsModalOpen(false)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <Button
        size="large"
        color={color}
        variant="outlined"
        loading={loading}
        onClick={() => setIsModalOpen(true)}
      >
        {title}
      </Button>

      <Modal
        title={<div style={{ fontSize: 20 }}>{title}</div>}
        open={isModalOpen}
        confirmLoading={loading}
        closable={!loading}
        maskClosable={!loading}
        onCancel={() => setIsModalOpen(false)}
        footer={
          <Flex gap={8}>
            <Button
              size="large"
              style={{ flex: 1 }}
              onClick={() => setIsModalOpen(false)}
            >
              Отменить
            </Button>
            <Button
              size="large"
              style={{ flex: 1 }}
              danger
              type="primary"
              onClick={handleConfirm}
            >
              Подтвердить
            </Button>
          </Flex>
        }
      >
        <Divider />
        <div style={{ fontSize: 16 }}>{confirmText}</div>
        <Divider />
      </Modal>
    </>
  )
}

export const ButtonChangeStatus = ({ budgetPeriod }: Props) => {
  const { byId, currentPeriodId } = budgetPeriod
  const loading = useUnit(changeStatusBudgetPeriodFx.pending)

  if (!currentPeriodId) return null

  const currentPeriod = byId.get(currentPeriodId)

  const handleChangePeriod = async (status: TStatusPeriod) => {
    try {
      await changeStatusBudgetPeriodFx({
        url: `/budget/budget_period/${currentPeriodId}/change_status`,
        body: { status },
      })
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {currentPeriod?.status === STATUS_PERIOD.OPEN_CREATE && (
        <ButtonWithConfirm
          title="Закрытие подачи стандартной заявки"
          confirmText="Вы уверены, что хотите закрыть подачу стандартных заявок?"
          loading={loading}
          color="red"
          onConfirm={() => handleChangePeriod(STATUS_PERIOD.CLOSE_CREATE)}
        />
      )}

      {currentPeriod?.status === STATUS_PERIOD.CLOSE_CREATE && (
        <ButtonWithConfirm
          title="Открытие для оплаты"
          confirmText="Вы уверены, что хотите открыть бюджетный период для оплаты?"
          loading={loading}
          color="green"
          onConfirm={() => handleChangePeriod(STATUS_PERIOD.OPEN_PAYMENT)}
        />
      )}

      {currentPeriod?.status === STATUS_PERIOD.OPEN_PAYMENT && (
        <ButtonWithConfirm
          title="Закрыть бюджетный период"
          confirmText="Вы уверены, что хотите закрыть бюджетный период для оплаты?"
          loading={loading}
          color="red"
          onConfirm={() => handleChangePeriod(STATUS_PERIOD.CLOSED)}
        />
      )}
    </>
  )
}
